import { ProductInventoryDoc } from '@gooduncles/gu-app-schema';
import { Select, message } from 'antd';
import { FC, useMemo } from 'react';

import useProductInventories from 'src/hooks/subscription/useProductInventories';

interface ProductInventorySelectorProps {
  handleProductInventoryChange: (productInventory: ProductInventoryDoc) => void;
}

const ProductInventorySelector: FC<ProductInventorySelectorProps> = ({ handleProductInventoryChange }) => {
  const { productInventories, isLoading } = useProductInventories();

  const inventoryOptions = useMemo(() => {
    return (
      productInventories?.map((productInventory) => ({
        label: productInventory.inventoryName,
        value: productInventory._id,
      })) ?? []
    ).sort((a, b) => a.label.localeCompare(b.label));
  }, [productInventories]);

  const handleOnChange = (value: string) => {
    const productInventory = productInventories?.find((productInventory) => productInventory._id === value);
    if (productInventory) {
      if (productInventory.quantity === Infinity) {
        message.info('운영하지 않는 재고를 선택하셨습니다.');
      }
      handleProductInventoryChange(productInventory);
    } else {
      message.error('재고를 찾을 수 없습니다.');
    }
  };

  return (
    <Select
      showSearch
      loading={isLoading}
      placeholder='재고 선택'
      options={inventoryOptions}
      onChange={handleOnChange}
      filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
    />
  );
};

export default ProductInventorySelector;
